import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toggleAlertas, abreModalBuscaCameras } from '../actions';

import todosAlertas from '../images/globe2.png';
import mosaico from '../images/icon_todos.svg';
import ad from '../images/ad.png';
import alertaEmergencia from '../images/icon_emergencia.svg';
import alertaRoubo from '../images/icon_roubo.svg';
import alertaPessoaSuspeita from '../images/icon_pessoasuspeita.svg';
import alertaDrogas from '../images/icon_drogas.svg';
import alertaCarroSuspeito from '../images/icon_carrosuspeito.svg';
import alertaVandalismo from '../images/icon_vandalismo.svg';
import alerta1h from '../images/icon_1h.svg';
import alerta24h from '../images/icon_24h.svg';
import alertaInformativo from '../images/icon_informativo.svg';
import alertaViolencia from '../images/icon_violencia.svg';
import busca from '../images/icon_busca.svg';
import alertaCamera from '../images/icon_camera.svg';
import firebase from '../util/firebase';
import Modal from 'simple-react-modal';

import RetinaImage from 'react-retina-image';
import ItemMenu from './ItemMenu';

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';


const ItemMenuWithIcon = ({ path, icons, tooltip, classe }) => (
  <div>
    <ItemMenu path={path}>
        <Tooltip html = {( <div className="menuTooltip"> { tooltip } </div> )} position="bottom" size="small">
          <div className={`circle circle-for-${classe}`}>
              <RetinaImage  className="image-menu" data-tip={tooltip} data-for={path} src={ icons }></RetinaImage>
          </div>
        </Tooltip>
    </ItemMenu>
  </div>
);

class Menu extends Component {

  constructor(props){
    super(props);
    this.state = {
      isAdmin: false,
      showModal: false,
      bannerUrl: "",
      bannerLink: "",
      file: null
    }
  }

  componentDidMount() {
    if (firebase.auth().currentUser) {
      setTimeout(function(){
        firebase.database().ref("usuarios/" + firebase.auth().currentUser.uid).on('value', snapshot => {
          this.setState({
            isAdmin: snapshot.val().role == "admin"
          });
        });
      }.bind(this), 1000);
    }
    this.closeModalBanner = this.closeModalBanner.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.onLinkChange = this.onLinkChange.bind(this);
  }

  showModalBanner() {
    this.setState({
      showModal: true
    });
    firebase.database().ref("system/bannerUrl").on('value', snapshot => {
      this.setState({
        bannerUrl: snapshot.val()
      });
    });
    firebase.database().ref("system/bannerLink").on('value', snapshot => {
      this.setState({
        bannerLink: snapshot.val()
      });
    });
  }

  closeModalBanner() {
    this.setState({
      showModal: false
    });
  }

  onLinkChange(e) {
    firebase.database().ref("system/bannerLink").set(e.target.value);
    this.setState({
      bannerLink: e.target.value
    });
  }

  onFileChange(e) {
    e.preventDefault();
    let imageAsFile = e.target.files[0];
    const storage = firebase.storage();
    console.log('start of upload');
    if(imageAsFile === '') {
      console.error(`not an image, the image file is a ${typeof(imageAsFile)}`);
    }
    const uploadTask = storage.ref(`/images/setec-banner/${imageAsFile.name}`).put(imageAsFile);
    uploadTask.on('state_changed', 
      (snapShot) => {
        console.log(snapShot);
    }, (err) => {
      console.log(err);
    }, () => {
      storage.ref('images/setec-banner').child(imageAsFile.name).getDownloadURL()
        .then(fireBaseUrl => {
          this.setState({
            bannerUrl: fireBaseUrl
          });
          firebase.database().ref("system/bannerUrl").set(fireBaseUrl);
        });
    })
  }

  render() {
    return (
      <nav className="mdl-navigation">
        <ItemMenu>
          <a className={`mdl-navigation__link search`}
            onClick={ () => this.navigation.props.abreModalBuscaCameras() }
            style={{ display: 'inherit' }}>
            <div className="circle-busca">
              <RetinaImage className="image-busca" src={ busca }></RetinaImage>
            </div>
          </a>
        </ItemMenu>
          
        <ItemMenu><ItemMenuWithIcon classe="tod" tooltip="Todos" path="/marcadores/todos" icons={ todosAlertas }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="eme" tooltip="Emergência" path="/marcadores/emergencia" icons={ alertaEmergencia }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="rou" tooltip="Roubo" path="/marcadores/roubo" icons={ alertaRoubo }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="pes" tooltip="Pessoa suspeita" path="/marcadores/pessoa-suspeita" icons={ alertaPessoaSuspeita }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="dro" tooltip="Drogas" path="/marcadores/drogas" icons={ alertaDrogas }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="car" tooltip="Veículo suspeito" path="/marcadores/veiculo-suspeito" icons={ alertaCarroSuspeito }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="vio" tooltip="Violência" path="/marcadores/violencia" icons={ alertaViolencia }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="van" tooltip="Vandalismo" path="/marcadores/vandalismo" icons={ alertaVandalismo }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="inf" tooltip="Informativo" path="/marcadores/informativo" icons={ alertaInformativo }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="1h" tooltip="1 hora" path="/marcadores/1h" icons={ alerta1h }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="24h" tooltip="24 horas" path="/marcadores/24h" icons={ alerta24h }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="cam" tooltip="Câmeras" path="/marcadores/camera" icons={ alertaCamera }></ItemMenuWithIcon></ItemMenu>
        <ItemMenu><ItemMenuWithIcon classe="24h" tooltip="Mosaico" path="/mosaico" icons={ mosaico }></ItemMenuWithIcon></ItemMenu>
        { this.state.isAdmin && 
          <a className={`mdl-navigation__link 24h`} onClick={ () => this.showModalBanner() }>
            <Tooltip html = {( <div className="menuTooltip"> { "Gerência Banner" } </div> )} position="bottom" size="small">
              <div className={'circle circle-for-24h'}>
                  <RetinaImage className="image-menu" style={{ width: "24px" }} data-tip={ "chupeta" } src={ ad }></RetinaImage>
              </div>
            </Tooltip>
          </a>
        }
        <Modal 
          show={this.state.showModal == true} 
          onClose={() => this.closeModalBanner()}
          style={{
            color: "#000000"
          }}
          containerStyle={{
            width: "540px"
          }}
        >
          Link: 
          <input type="text" style={{ width: "500px" }} value={ this.state.bannerLink } onChange={this.onLinkChange}></input> <br /><br />
          Banner:
          <img 
            src={ this.state.bannerUrl } 
            width="500px" 
          /><br /><br />
          <form onSubmit={this.submitFile}>
            <input label='upload file' type='file' onChange={this.onFileChange} />
          </form>
        </Modal>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  route: state.route,
});
const mapDispatchToProps = (dispatch) => {
  return {
    toggleAlertas: (tipo) => dispatch(toggleAlertas(tipo)),
    abreModalBuscaCameras: () => dispatch(abreModalBuscaCameras()),
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu.js